// extracted by mini-css-extract-plugin
module.exports = {"eventsList":"style_eventsList__MR0HR"};